'use strict'

export let norwegian_endStage={
  Overview: {
    fields: {
      period: {
        title: "Etappens tidsperiode",
        help: "Angi faktisk tidsperiod for denne etappen. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        help: "Hva var intensjonen eller målet med denne etappen, og oppnådde vi det? Hadde vi noen gjennombrudd eller store feil?",
        description:"Beskriv målet med denne etappen og i hvilken grad målet har blitt oppnådd"
      },
      performedAchivements: {
        title: "Levert i denne etappen",
        help: "Hvilke arbeidspakker ble gjennomført eller fullført i denne etappen? Hvilke produkter ble levert i løpet av etappen? Var det noen planlagte produkter som ikke ble fullført i denne etappen? Har det blitt gjort noen korrigerende tiltak i løpet av etappen?",
        description: "Beskriv produktene som er levert i denne etappen"

      },

      benefits: {
        help: "Er vi på rett spor for å levere den ønskede avkastningen på investeringen etter at denne etappen er fullført? Hvis ikke, hva er forskjellen og hvorfor? Er det lagt til nye gevinster eller fjernet noen gevinster fra prosjektbegrunnelsen i løpet av denne etappen?",
        description: "Beskriv hvordan de planlagte gevinstene og prosjektbegrunnelsen har blitt påvirket i løpet av etappen"
      },
      time: {
        help:"Hva var den planlagte tidsperioden for denne etappen? Holdt vi oss innenfor tidsgrensen? Hvis ikke, hva var hovedårsaken? Brukte vi noe av toleransen for tid i denne etappen? Oppstod det noen saker som enderet tidsperioden for etappen - i så fall, hva endret vi fra-til og hvorfor? Hvordan er prognosen på gjenstående tid på prosjektet, og hvordan er dette i forhold til sist godkjente prosjektplan?",
        description: "Beskriv målene for tid i denne etappen og i hvilken grad etappen ble gjennomført innenfor planlagt tidsperiode"
      },
      cost: {
        help:"Hva var den planlagte kostnaden for denne etappen? Holdt vi oss innenfor den planlagte kostnaden? Hvis ikke, hva var hovedårsaken? Brukte vi noe av toleransen for kostand i denne etappen? Oppstod det noen saker som endret kostnaden for etappen - i så fall, hva endret vi fra-til og hvorfor? Hva er prognosen på gjenstående kostand for prosjektet, og hvordan er dette i forhold til sist godkjente prosjektplan?",
        description: "Oppsummer den planlagte kostnaden for etappen, hva den faktiske kostnaden endte opp med å bli og forklar eventuelle avvik"
      },

      quality: {
        help:`Hadde vi nødvendig klarhet i krav, formater eller andre kvalitetskriterier for de planlagte leveransene i etappen?
          Har leverte produkter i denne etappen oppfylt de avtalte kravene eller kvalitetskriteriene?
          Hvis ikke, hvilke produkter oppfylte ikke kriteriene og hvorfor?
          Har akseptmetodene (testing, vurderinger ...) for produktene i denne etappen blitt brukt som avtalt? Hvordan vurderer vi nå den samlede kvaliteten som leveres i prosjektet, og vil vi oppnå det nødvendige kvalitetsnivået for prosjektets leveranser?`,
        description: "Beskriv i hvilken grad leveransene i denne etappen har oppfylt kravene, formater eller andre kvalitetskriterier som ble avtalt før oppstart av etappen"
      },
      scope: {
        help:`Hadde vi tilstrekkelig klarhet i hva som skulle leveres når denne etappen? Har vi levert de planlagte produktene? Gjorde vi mer eller mindre? Endret vi noe omfang i løpet av denne etappen? Har vi tilstrekkelig klarhet i hva som skal leveres for resten av prosjektet - hvis ikke, hva mangler?`,
        description: "Beskriv i hvilken grad denne etappen leverte de planlagte produktene"
      },

      risk: {
        help:"Har vi klart å holde risikonivået på ønsket nivå i løpet av denne etappen? Har den totale risikoeksponeringen økt eller blitt redusert for prosjektet i denne etappen? Har det blitt identifisert nye alvorlige risiki i denne etappen? Har det blitt gjennomført vesentlige risikoreduserende tiltak i løpet av denne etappen?",
        description: "Beskriv hvordan risikonivået for prosjektet har endret seg i løpet av denne etappen"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/norwegian_endStage.js